// import NurowzImg from '../../../assets/images/base/Nowruz.PNG';
import Logo from '../../../assets/images/icons/splash-carfillo-logo.png';

const Splash = ({ showSplash }) => {
  if (!showSplash) {
    return null;
  }

  return (
    <div className="splash-screen">
      <img alt="logo" height={265} src={Logo} width={265} />
      <h1>بــــازار آنلایـــن فـــروش عمـــــــده روغن موتور و لوازم یدکی خودرو</h1>
      {/* <img alt="nurowz" className="NurowzImg" src={NurowzImg} /> */}
    </div>
  );
};

export default Splash;
